/* Copyright (c) 2020-present CloudIO Inc */

import { useStateXAtomValue } from '@cloudio-saas/statex';
import { useMonaco } from '@monaco-editor/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Box } from '@mui/material';
import { Platform } from 'componentregistry';
import CodeInput from 'custom/CodeInput';
import useWindowSize from 'hooks/useWindowSize';
import { serverLogsActiveEntryAtom } from 'layout/Header/HeaderState';
import { memo } from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from 'theme/Theme';
import { initLogLanguage } from './language-log';
import { ServerLogsFilter } from './ServerLogsFilter';

function PublicLog({ platform }: { platform: Platform }) {
  const { key } = useParams() as {
    key: string;
  };
  const monaco = useMonaco();
  const theme = useTheme();
  initLogLanguage(monaco, theme);
  const activeLog = useStateXAtomValue(serverLogsActiveEntryAtom);

  const [ww, wh] = useWindowSize();
  window.document.title = `Log: ${activeLog?.fileName ?? 'Choose a log file'}`;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box>
        <ServerLogsFilter platform={platform} publicLogKey={key} />
        <CodeInput
          darkMode={theme.palette.mode !== 'light'}
          height={wh - 40}
          language="log"
          value={activeLog?.logEntries?.join('\n') ?? ''}
          width={ww}
          disabled
          theme="logview"
          loadingMessage="Loading data..."
        />
      </Box>
    </LocalizationProvider>
  );
}

export default memo(PublicLog);
